/**
 * Glyphs for the footer's social row. Only the platforms Diolo actually uses
 * are drawn — anything else configured in Shop.socialLinks falls back to a
 * text link, so adding a new network never renders a wrong-looking icon.
 *
 * All are stroke-drawn on the same 24px grid and inherit currentColor, so
 * they sit at the weight of the footer type rather than shouting over it.
 */
import type { ReactNode } from "react";

const GLYPHS: Record<string, ReactNode> = {
  instagram: (
    <>
      <rect x="3" y="3" width="18" height="18" rx="5" />
      <circle cx="12" cy="12" r="4" />
      <circle cx="17.4" cy="6.6" r="0.9" fill="currentColor" stroke="none" />
    </>
  ),
  tiktok: (
    <>
      <path d="M15.5 3v10.6a3.9 3.9 0 1 1-3.9-3.9c.34 0 .67.04.98.13" />
      <path d="M15.5 3c.4 2.4 2.2 4.1 4.5 4.3" />
    </>
  ),
};

export const hasSocialIcon = (name: string) => name.toLowerCase() in GLYPHS;

export function SocialIcon({ name, className }: { name: string; className?: string }) {
  const glyph = GLYPHS[name.toLowerCase()];
  if (!glyph) return null;
  return (
    <svg
      viewBox="0 0 24 24"
      className={className}
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {glyph}
    </svg>
  );
}
